var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _c("div", { staticClass: "section-head" }, [_vm._v("存款配置")]),
      _c(
        "div",
        { staticClass: "red-tiers-actions" },
        [
          _c(
            "el-button",
            {
              attrs: { type: "primary", size: "mini" },
              on: { click: _setup.addTier },
            },
            [_vm._v("新增")]
          ),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "status-tip", staticStyle: { "margin-bottom": "8px" } },
        [_vm._v("保存时将按存款金额从低到高排序")]
      ),
      _c(
        "el-table",
        {
          staticClass: "tier-table",
          attrs: {
            data: _vm.localForm.firstDepositTiers,
            border: "",
            size: "mini",
          },
        },
        [
          _c("el-table-column", {
            attrs: { label: "序号", width: "56", align: "center" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [_vm._v(_vm._s(scope.$index + 1))]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { label: "存款金额", "min-width": "200" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c(
                      "div",
                      {
                        staticStyle: {
                          display: "flex",
                          "align-items": "center",
                          gap: "6px",
                        },
                      },
                      [
                        _c("span", { staticClass: "tier-gte-prefix" }, [
                          _vm._v("≥"),
                        ]),
                        _c("el-input-number", {
                          staticStyle: { width: "120px" },
                          attrs: {
                            min: 0,
                            precision: 2,
                            controls: false,
                            size: "mini",
                          },
                          model: {
                            value: scope.row.amount_yuan,
                            callback: function ($$v) {
                              _vm.$set(scope.row, "amount_yuan", $$v)
                            },
                            expression: "scope.row.amount_yuan",
                          },
                        }),
                        _c("span", { staticClass: "rule-suffix" }),
                      ],
                      1
                    ),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { label: "奖励类型", "min-width": "120" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c(
                      "el-select",
                      {
                        staticStyle: { width: "110px" },
                        attrs: { size: "mini" },
                        on: {
                          change: function ($event) {
                            return _setup.onRewardTypeChange(scope.$index)
                          },
                        },
                        model: {
                          value: scope.row.reward_type,
                          callback: function ($$v) {
                            _vm.$set(scope.row, "reward_type", $$v)
                          },
                          expression: "scope.row.reward_type",
                        },
                      },
                      [
                        _c("el-option", {
                          attrs: {
                            label: "随机奖励",
                            value: _setup.REWARD_RANDOM,
                          },
                        }),
                        _c("el-option", {
                          attrs: {
                            label: "固定奖励",
                            value: _setup.REWARD_FIXED,
                          },
                        }),
                        _c("el-option", {
                          attrs: { label: "不赠送", value: _setup.REWARD_NONE },
                        }),
                      ],
                      1
                    ),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { label: "奖励金额", "min-width": "260" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    Number(scope.row.reward_type) === _setup.REWARD_RANDOM
                      ? _c(
                          "div",
                          {
                            staticStyle: {
                              display: "flex",
                              "align-items": "center",
                              gap: "6px",
                              "flex-wrap": "wrap",
                            },
                          },
                          [
                            _c("el-input-number", {
                              staticStyle: { width: "88px" },
                              attrs: {
                                min: 0,
                                precision: 2,
                                controls: false,
                                size: "mini",
                              },
                              model: {
                                value: scope.row.reward_count_min,
                                callback: function ($$v) {
                                  _vm.$set(scope.row, "reward_count_min", $$v)
                                },
                                expression: "scope.row.reward_count_min",
                              },
                            }),
                            _c("span", { staticClass: "rule-suffix" }, [
                              _vm._v("~"),
                            ]),
                            _c("el-input-number", {
                              staticStyle: { width: "88px" },
                              attrs: {
                                min: 0,
                                precision: 2,
                                controls: false,
                                size: "mini",
                              },
                              model: {
                                value: scope.row.reward_count_max,
                                callback: function ($$v) {
                                  _vm.$set(scope.row, "reward_count_max", $$v)
                                },
                                expression: "scope.row.reward_count_max",
                              },
                            }),
                            _c("span", { staticClass: "rule-suffix" }, [
                              _vm._v("元"),
                            ]),
                          ],
                          1
                        )
                      : Number(scope.row.reward_type) === _setup.REWARD_FIXED
                      ? _c("el-input-number", {
                          staticStyle: { width: "120px" },
                          attrs: {
                            min: 0,
                            precision: 2,
                            controls: false,
                            size: "mini",
                            placeholder: "请输入奖励金额",
                          },
                          model: {
                            value: scope.row.reward_count_yuan,
                            callback: function ($$v) {
                              _vm.$set(scope.row, "reward_count_yuan", $$v)
                            },
                            expression: "scope.row.reward_count_yuan",
                          },
                        })
                      : _c("span", { staticClass: "rule-suffix muted" }, [
                          _vm._v("-"),
                        ]),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { label: "操作", width: "72", align: "center" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c(
                      "el-button",
                      {
                        staticClass: "danger-button",
                        attrs: { type: "text", size: "small" },
                        on: {
                          click: function ($event) {
                            return _setup.removeTier(scope.$index)
                          },
                        },
                      },
                      [_vm._v("删除")]
                    ),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
      _c(
        "el-form-item",
        {
          staticStyle: { "margin-top": "16px" },
          attrs: {
            "label-width": "140px",
            label: "奖励稽核倍数",
            required: "",
          },
        },
        [
          _c("el-input-number", {
            staticClass: "rule-input-num",
            attrs: { min: 0, precision: 2, controls: false },
            model: {
              value: _vm.localForm.firstDepositRule.multiple,
              callback: function ($$v) {
                _vm.$set(_vm.localForm.firstDepositRule, "multiple", $$v)
              },
              expression: "localForm.firstDepositRule.multiple",
            },
          }),
          _c("span", { staticClass: "rule-suffix" }, [_vm._v("倍")]),
        ],
        1
      ),
      _c(
        "el-form-item",
        {
          staticClass: "form-item-vips",
          attrs: {
            label: "活动对象",
            prop: "vips",
            "label-width": "140px",
            required: "",
          },
        },
        [
          _c(
            "div",
            { staticClass: "vips-wrap", staticStyle: { width: "80%" } },
            [
              _c(
                "el-checkbox",
                {
                  attrs: {
                    indeterminate: _setup.vipIndeterminate,
                    value: _setup.isAllVipChecked,
                  },
                  on: { change: _setup.onVipCheckAllChange },
                },
                [_vm._v(" 全选 ")]
              ),
              _c(
                "el-checkbox-group",
                {
                  staticClass: "vips-group",
                  on: { change: _setup.syncVipCheckAllState },
                  model: {
                    value: _vm.localForm.vips,
                    callback: function ($$v) {
                      _vm.$set(_vm.localForm, "vips", $$v)
                    },
                    expression: "localForm.vips",
                  },
                },
                _vm._l(_vm.vipOptions, function (item) {
                  return _c(
                    "el-checkbox",
                    { key: item.value, attrs: { label: item.value } },
                    [_vm._v(_vm._s(item.label))]
                  )
                }),
                1
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }